import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import {
  currentOrganizationSelector,
  orgTariffesSelector,
  userSelector,
} from "../../store/selectors";
import "./TariffesScreen.css";
import AppLogo from "../../assets/AppLogoBlue.svg";
import { Switch } from "@mui/material";
import uncheckedIcon from "../../assets/unchecked.svg";
import checkedIcon from "../../assets/checked.svg";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import { ReactComponent as StarIcon } from "../../assets/starIconPurple.svg";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import { fetchPublicTariffes } from "../../store/tariffesSlice";
import { createUserSubscription } from "../../store/usersSlice";
import PaymentBackdrop from "../../assets/PaymentBackdrop.png";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import CloseButton from "../../components/CloseButton/CloseButton";
import toast from "react-hot-toast";
import useIsMobile from "../../hooks/useIsMobile";
const shownTariffesIds = [8, 11, 22];

const TariffesScreen = () => {
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [tariffesInfo, setTariffesInfo] = useState([]);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [activeTariffIndex, setActiveTariffIndex] = useState(0);
  const currentOrganizationsTariffes = useSelector(orgTariffesSelector);
  const [chosenTariff, setChosenTariff] = useState(null);
  const [isYearlyActive, setIsYearlyActive] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchPublicTariffes()).then((res) => {
      if (!res.error) {
        const neededTariffes = res.payload.filter((tariff) =>
          shownTariffesIds.includes(tariff.id)
        );
        setTariffesInfo(neededTariffes);
      }
    });
  }, []);

  useEffect(() => {
    const currentOrgTariff =
      currentOrganizationsTariffes[currentOrganization.id];
    if (currentOrgTariff) {
      if (currentOrgTariff.plan && currentOrgTariff.plan.id === 11) {
        setActiveTariffIndex(1);
      } else if (currentOrgTariff.plan && currentOrgTariff.plan.id === 22) {
        setActiveTariffIndex(2);
      } else {
        setActiveTariffIndex(0);
      }
    }
  }, [currentOrganizationsTariffes]);

  const renderAttributeRow = (tariffAttr, isPopular = false) => {
    return (
      <div className={`tariff-attribute-row ${isPopular && "popular"}`}>
        <StarIcon
          style={{
            transform: "scale(1.7)",
            fill: isPopular ? "#333B4B" : "#F1F7FF",
          }}
          width={12}
          height={24}
        />
        <span>
          {tariffAttr.name}: {tariffAttr.value}
        </span>
      </div>
    );
  };

  const renderOrdinaryTariff = (tariffInfo, index) => {
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");
    return (
      <div
        className={`${isMobile ? "tariff-item-mobile" : "tariff-item"} ${
          index === activeTariffIndex ? "active" : ""
        }`}
      >
        {index === activeTariffIndex && (
          <div className="tariff-active-label">Текущий</div>
        )}
        <span className="tariff-item-description">
          {tariffInfo?.description || "..."}
        </span>
        <span className="tariff-item-title">{tariffInfo?.name || "..."}</span>
        <span className="tariff-item-price">
          {isYearlyActive
            ? yearPrice?.price + "₽" || "..."
            : monthPrice?.price + "₽" || "..."}
        </span>
        {tariffInfo &&
          tariffInfo.attributes.map((tariffAttr) => {
            return renderAttributeRow(tariffAttr);
          })}
        <div className="tariff-item-all-list">Посмотреть все функции</div>
        <div style={{ flex: 1 }} />
        <div
          className={`tariff-try-button ${
            index === activeTariffIndex && "inactive"
          }`}
          onClick={() => {
            setChosenTariff(tariffInfo);
            setIsPaymentModalVisible(true);
            // const price = isYearlyActive ? yearPrice : monthPrice;
            // if (index !== activeTariffIndex) {
            //   dispatch(
            //     createUserSubscription({
            //       organizationId: currentOrganization.id,
            //       subscriptionData: {
            //         planVersionPriceId: price.id,
            //       },
            //     })
            //   ).then((res) => {
            //     if (!res.error) {
            //       const link = res.payload.payment.paymentLink;
            //       window.location.href = link;
            //     }
            //   });
            // }
          }}
        >
          {index === activeTariffIndex
            ? "Активен"
            : index < activeTariffIndex
            ? "Перейти"
            : "Попробовать"}
        </div>
      </div>
    );
  };

  const renderPopularTariff = (tariffInfo, index) => {
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");
    return (
      <div
        className={`${
          isMobile ? "tariff-item-popular-mobile" : "tariff-item-popular"
        }`}
      >
        {index === activeTariffIndex && (
          <div className="tariff-active-label-popular">Текущий</div>
        )}
        {index !== activeTariffIndex && (
          <div className="tariff-popular-label">Cамый популярный тариф</div>
        )}
        <div
          style={{
            paddingLeft: 15,
            paddingRight: 15,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="tariff-item-description popular">
            {tariffInfo?.description || "..."}
          </span>
          <span className="tariff-item-title">{tariffInfo?.name || "..."}</span>
          <span className="tariff-item-price">
            {isYearlyActive
              ? yearPrice?.price + "₽" || "..."
              : monthPrice?.price + "₽" || "..."}
          </span>
        </div>
        <div style={{ flex: 1 }} />
        <div className="tariff-item-popular-backdrop">
          {tariffInfo &&
            tariffInfo.attributes.map((tariffAttr) => {
              return renderAttributeRow(tariffAttr, true);
            })}
          <div className="tariff-item-all-list">Посмотреть все функции</div>
          {/* <div style={{ flex: 1 }} /> */}
          <div
            className={`tariff-try-button ${
              index === activeTariffIndex && "inactive"
            }`}
            onClick={() => {
              setChosenTariff(tariffInfo);
              setIsPaymentModalVisible(true);
              // const price = isYearlyActive ? yearPrice : monthPrice;
              // if (index !== activeTariffIndex) {
              //   dispatch(
              //     createUserSubscription({
              //       organizationId: currentOrganization.id,
              //       subscriptionData: {
              //         planVersionPriceId: price.id,
              //       },
              //     })
              //   ).then((res) => {
              //     if (!res.error) {
              //       const link = res.payload.payment.paymentLink;
              //       window.location.href = link;
              //     }
              //   });
              // }
            }}
          >
            {index === activeTariffIndex ? "Активен" : "Попробовать"}
          </div>
        </div>
      </div>
    );
  };

  const renderTariffesRow = () => {
    return (
      <div className={isMobile ? "tariffes-row-mobile" : "tariffes-row"}>
        {renderOrdinaryTariff(tariffesInfo[0], 0)}
        {renderPopularTariff(tariffesInfo[1], 1)}
        {renderOrdinaryTariff(tariffesInfo[2], 2)}
      </div>
    );
  };

  const renderPaymentTariffInfo = (tariffInfo) => {
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");
    const isChosenTariff = chosenTariff.id === tariffInfo.id;
    return (
      <div
        style={{
          width: "100%",
          height: 80,
          backgroundColor: isChosenTariff ? "#717B8E50" : "transparent",
          border: isChosenTariff ? "1px solid #3496FF" : "1px solid #717B8E",
          borderRadius: 80,
          boxSizing: "border-box",
          cursor: "pointer",
          padding: 20,
          paddingTop: 15,
        }}
        onClick={() => setChosenTariff(tariffInfo)}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {isChosenTariff ? (
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: "#3496FF",
                  border: "1px solid #3496FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 11,
                    height: 11,
                    borderRadius: 10,
                    backgroundColor: "transparent",
                    border: "3px solid #383c43",
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: "transparent",
                  border: "1px solid #717B8E",
                }}
              />
            )}
            <span
              style={{
                marginLeft: 10,
                fontSize: 24,
                fontWeight: 500,
                color: isChosenTariff ? "#3496FF" : "#C1C7D4",
              }}
            >
              {tariffInfo.name}
            </span>
          </div>
          <span
            style={{
              fontSize: 24,
              fontWeight: 500,
              color: isChosenTariff ? "#FFFCFC" : "#C1C7D4",
            }}
          >{`${
            isYearlyActive ? yearPrice?.price || "0" : monthPrice?.price || "0"
          } ₽`}</span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            boxSizing: "border-box",
            paddingLeft: 32,
          }}
        >
          <span
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: isChosenTariff ? "#C1C7D4" : "#717B8E",
            }}
          >
            {tariffInfo.description}
          </span>
          <span
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: isChosenTariff ? "#C1C7D4" : "#717B8E",
            }}
          >{`в ${isYearlyActive ? "год" : "месяц"}`}</span>
        </div>
      </div>
    );
  };

  const handleConfirmPayment = () => {
    if (!isChecked || isLoading) return;
    setIsLoading(true);
    const monthPrice =
      chosenTariff &&
      chosenTariff.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      chosenTariff &&
      chosenTariff.prices.find((price) => price.periodUnit === "YEAR");

    const price = isYearlyActive ? yearPrice : monthPrice;
    dispatch(
      createUserSubscription({
        organizationId: currentOrganization.id,
        subscriptionData: {
          planVersionPriceId: price.id,
        },
      })
    ).then((res) => {
      if (!res.error) {
        console.log(res);
        setIsLoading(false);
        const link = res.payload.payment.paymentLink;
        if (link) {
          window.location.href = link;
        }
      } else {
        toast.error(res.payload);
        setIsLoading(false);
      }
    });
  };

  const getPaymentTitle = () => {
    return (
      <>
        <span className="payment-title">Подключение тарифа</span>
        <div>
          <span className="payment-title" style={{ color: "#3496FF" }}>
            {chosenTariff.name}
          </span>
          <span className="payment-title">{` с ${
            isYearlyActive ? "ежегодной" : "ежемесячной"
          } оплатой`}</span>
        </div>
        <div>
          <span className="payment-title">на аккаунт</span>
          <span
            className="payment-title"
            style={{ color: "#717B8E" }}
          >{` ${user.email}`}</span>
        </div>
      </>
    );
  };

  if (isPaymentModalVisible) {
    return (
      <div className="App">
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            zIndex: 1,
          }}
        >
          <img
            src={PaymentBackdrop}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            padding: "20px 19px",
          }}
        >
          <div
            className={"mainScreenHeader"}
            style={{
              backgroundColor: "transparent",
              width: "95.4%",
            }}
          >
            <div className="header-left">
              <div
                onClick={() => navigate("/home", { replace: true })}
                className={"mainScreen-logoBlock"}
                style={{ cursor: "pointer" }}
              >
                <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
              </div>
            </div>
            <div className="header-actions">
              <NotificationsPopup />
              <ProfilePopup />
            </div>
          </div>
          <div
            style={{
              flex: 1,
              height: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",

              marginRight: 33,
            }}
          >
            <div
              style={{
                width: 650,
                height: "85%",
                backgroundColor: "#1F242E",
                borderRadius: 50,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                boxSizing: "border-box",
                padding: 48,
                paddingTop: 48,
                paddingBottom: 32,
              }}
            >
              <CloseButton onClose={() => setIsPaymentModalVisible(false)} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                {getPaymentTitle()}
              </div>
              <div
                style={{
                  width: "70%",
                  height: 42,
                  backgroundColor: "#333B4B",
                  display: "flex",
                  flexDirection: "row",
                  borderRadius: 80,
                  cursor: "pointer",
                  marginTop: 28,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    borderTopLeftRadius: 80,
                    borderBottomLeftRadius: 80,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: "pointer",
                    justifyContent: "center",
                    color: isYearlyActive ? "#C1C7D4" : "#F1F7FF",
                    background: isYearlyActive
                      ? "#333B4B"
                      : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  }}
                  onClick={() => setIsYearlyActive(false)}
                >
                  Ежемесячно
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTopRightRadius: 80,
                    borderBottomRightRadius: 80,
                    fontSize: 14,
                    fontWeight: 500,
                    color: !isYearlyActive ? "#C1C7D4" : "#F1F7FF",
                    background: !isYearlyActive
                      ? "#333B4B"
                      : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  }}
                  onClick={() => setIsYearlyActive(true)}
                >
                  Ежегодно
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "-25%",
                    right: 20,
                    padding: "2px 7px",
                    borderRadius: 20,
                    color: "#427FFF",
                    backgroundColor: "#F1F7FF",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  Выгода 25%
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  width: "100%",
                  marginTop: 20,
                }}
              >
                {tariffesInfo.map((tariffInfo) =>
                  renderPaymentTariffInfo(tariffInfo)
                )}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: 48,
                  cursor: "pointer",
                }}
                onClick={() => setIsChecked(!isChecked)}
              >
                <img
                  src={isChecked ? checkedIcon : uncheckedIcon}
                  alt="options"
                  style={{
                    width: 24,
                    height: 24,
                  }}
                />
                <span
                  style={{
                    color: "#717B8E",
                    textAlign: "left",
                    fontSize: 14,
                    marginLeft: 10,
                    fontWeight: 500,
                  }}
                >
                  Нажимая кнопку вы разрешаете компании 7cut взимать с вас плату
                  в соответствии с условиями, пока не отмените подписку
                </span>
              </div>
              <div
                style={{
                  width: "100%",
                  height: 54,
                  borderRadius: 80,
                  background:
                    "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#F1F7FF",
                  fontSize: 16,
                  opacity: isLoading || !isChecked ? 0.7 : 1,
                  marginTop: 16,
                  cursor: "pointer",
                  fontWeight: 500,
                }}
                onClick={() => handleConfirmPayment()}
              >
                {isLoading ? "Готовим ваш тариф..." : "Подключить тариф"}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 15,
                  fontSize: 14,
                  fontWeight: 500,
                  alignSelf: "flex-start",
                  color: "#717B8E",
                }}
              >
                <span>При возникновении вопросов</span>{" "}
                <div
                  style={{ marginLeft: 5, color: "#3496FF", cursor: "pointer" }}
                  onClick={() => navigate("/support")}
                >
                  обратитесь в поддержку
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div
        className={
          isMobile ? "tariffes-container-mobile" : "tariffes-container"
        }
        style={{ alignItems: "flex-start" }}
      >
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="tariffes" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main className={isMobile ? "tariffes-main-mobile" : "tariffes-main"}>
          <div
            className={
              isMobile ? "tariffes-title-block-mobile" : "tariffes-title-block"
            }
          >
            <span className="tariffes-title">Тарифный план</span>
            <div
              className={
                isMobile
                  ? "tariffes-switch-block-mobile"
                  : "tariffes-switch-block"
              }
            >
              <div className="tariffes-switch-block-top">
                <span
                  className="tariffes-switch-label"
                  style={{ color: "#c4c4c4" }}
                >
                  Ежемесячно
                </span>
                <Switch
                  sx={{
                    "&.MuiSwitch-root .MuiSwitch-switchBase": {
                      color: "#F1F7FF",
                      "&.Mui-checked": {
                        "& + .MuiSwitch-track": {
                          opacity: 1,
                          backgroundColor: "#3496FF",
                        },
                      },
                    },

                    "&.MuiSwitch-root .Mui-checked": {
                      color: "#F1F7FF",
                    },
                    "&.MuiSwitch-root .MuiSwitch-track": {
                      opacity: 0.5,
                      backgroundColor: "#b7d1dc",
                    },
                    ".Mui-checked .MuiSwitch-track": {
                      opacity: 0.5,
                      backgroundColor: "red",
                    },
                  }}
                  slotProps={{ input: { "aria-label": "controlled" } }}
                  checked={isYearlyActive}
                  onChange={(e) => setIsYearlyActive(!isYearlyActive)}
                />
                <span className="tariffes-switch-label">Ежегодно</span>
              </div>
              <div className="tariffes-switch-block-bottom">
                <span className="tariffes-switch-block-bottom-label">
                  Выгода 25%
                </span>
              </div>
            </div>
          </div>
          {renderTariffesRow()}
        </main>
      </div>
    </div>
  );
};

export default TariffesScreen;
